module.exports = __webpack_public_path__ + "img/img_clients12.406a8875.jpg";